import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { ToastContainer, Slide, toast } from 'react-toastify';
import i18n from '../i18n';

import rootReducer from '../redux/reducers/index';
import { routes } from '../routes';
import { SESSION_EXPIRED_FLAG } from '../constants/login';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-toastify/dist/ReactToastify.css';
import '../i18n';
import CookieConsent from './CookieConsent';
import { CookiesProvider } from 'react-cookie';

const store = createStore(
  rootReducer,
  //add this to enable redux devtools
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

const router = createBrowserRouter(routes);

function App() {
  useEffect(() => {
    if (!sessionStorage.getItem(SESSION_EXPIRED_FLAG)) return;
    sessionStorage.removeItem(SESSION_EXPIRED_FLAG);
    setTimeout(() => {
      toast.error(i18n.t('error.session.expired'));
    }, 300);
  }, []);

  return (
    <Provider store={store}>
      <div className="app-wrapper" id="app-wrapper-id">
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <RouterProvider router={router} />
          <CookieConsent />
        </CookiesProvider>
      </div>

      <ToastContainer hideProgressBar={true} icon={false} transition={Slide} autoClose={3000} />
    </Provider>
  );
}

export default App;
